'use client'

import { CollectionListingNoFilter } from '@/app/[locale]/collection/_components/collection-listing-no-filter'
import { CollectionContainer } from '@/components/common/collection/collection-container'
import { Tabs } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { EossBanner } from './banner'

interface FlashSaleProductsSliderProps {
  slug: string
  filterTabs?: { label: string; value: string }[]
  banner?: { desktop: string; mobile: string }
  className?: string
  triggerClassName?: string
  tabClassName?: string
  key_filter: string
  defaultTab?: string
}

export const EossFilterProduct = ({
  slug,
  filterTabs,
  banner,
  className,
  triggerClassName,
  tabClassName,
  key_filter,
  defaultTab,
}: FlashSaleProductsSliderProps) => {
  const [filter, setFilter] = useState<{ key: string; value: string }[]>([
    {
      key: 'limit',
      value: '12',
    },
    {
      key: 'sort',
      value: 'bestseller',
    },
    {
      key: key_filter,
      value: defaultTab || '',
    },
  ])

  const onChangeTab = (value: string) => {
    setFilter([...filter, { key: key_filter, value }])
  }

  return (
    <CollectionContainer className={cn('py-8', className)}>
      <EossBanner
        desktop={banner?.desktop || ''}
        mobile={banner?.mobile || ''}
      />
      <div className='flex items-center justify-between'>
        <Tabs
          className={cn('my-4 p-0 lg:mt-6', tabClassName)}
          triggerClassName={cn(
            'text-sm leading-tight font-normal font-pangea px-4 py-2 lg:px-6 lg:py-3',
            triggerClassName
          )}
          variant='filter'
          options={filterTabs || []}
          defaultValue={defaultTab || slug}
          onChange={onChangeTab}
        />
      </div>

      <CollectionListingNoFilter slug={slug} filter={filter} isHideId={true} />
    </CollectionContainer>
  )
}
